export default __webpack_public_path__ + "static/media/will_cover.51ccda00.jpeg";